var scorm = pipwerks.SCORM; //Shortcut
var lmsConnected = false;
var unloaded = false;
var useLocal = false;
var courseURL = btoa(window.location.href.toString());
var progressURL = 'progress' + courseURL;
var bookmarkURL = 'bookmark' + courseURL;

function initCourse() {
	var bookmarkLocal;
	var localData;
	if (useLocal && storageAvailable('localStorage')) {
		bookmarkLocal = localStorage.getItem(bookmarkURL);
		localData = JSON.parse(localStorage.getItem(progressURL));
	}
	//scorm.init returns a boolean
	lmsConnected = scorm.init();
	//If the scorm.init function succeeded...
	if (lmsConnected) {
		siLog('SCORM', 'INIT', 'SUCCESS: Course is now connected with the LMS!');
		var completionstatus;
		var learnername;
		var rawData = scorm.get('cmi.suspend_data');
		var bookmarkScorm;
		var scormData;
		if (scorm.version === '2004') {
			completionstatus = scorm.get('cmi.completion_status');
			learnername = scorm.get('cmi.learner_name');
			bookmarkScorm = scorm.get('cmi.location');
		} else {
			completionstatus = scorm.get('cmi.core.lesson_status');
			learnername = scorm.get('cmi.core.student_name');
			bookmarkScorm = scorm.get('cmi.core.lesson_location');
		}
		if (rawData && typeof rawData === 'string') {
			scormData = JSON.parse(rawData);
			slideCompletion = scormData;
		} else if (localData) {
			slideCompletion = localData;
		}

		if (bookmarkScorm) {
			bookmarkedSlide = bookmarkScorm;
		} else if (bookmarkLocal) {
			bookmarkedSlide = bookmarkLocal;
		} else {
			bookmarkedSlide = 1;
		}
		window.addEventListener('unload', unloadHandler);
		window.addEventListener('beforeunload', unloadHandler);
		//If the course couldn't connect to the LMS for some reason...
	} else {
		//... let's alert the user then close the window.
		siLog('SCORM', 'INIT', 'ERROR: Course could not connect with the LMS');
		if (localData) {
			slideCompletion = localData;
		}
		if (bookmarkLocal) {
			bookmarkedSlide = bookmarkLocal;
		} else {
			bookmarkedSlide = 1;
		}
	}
}

function setScormCompletion() {
	//If the lmsConnection is active...
	if (lmsConnected) {
		var success;
		//... try setting the course status to "completed"
		if (scorm.version === '2004') {
			success = scorm.set('cmi.completion_status', 'completed');
			scorm.set('cmi.success_status', 'passed');
			scorm.set('cmi.score.raw', '100');
			scorm.set('cmi.score.scaled', '1');
			// scorm.set("cmi.score.min", globalVar.minScore);
			// scorm.set("cmi.score.max", globalVar.maxScore);
			// scorm.set("adl.nav.request", "exit")
		} else {
			success = scorm.set('cmi.core.lesson_status', 'completed');
			scorm.set('cmi.core.score.raw', '100');
			// scorm.set("cmi.core.score.min", globalVar.minScore);
			// scorm.set("cmi.core.score.max", globalVar.maxScore);
		}
		//If the course was successfully set to "completed"...
		if (success) {
			scorm.save();
			siLog('SCORM', 'COMPLETE', 'SUCCESS: Course was successfully set to complete!');
			//If the course couldn't be set to completed for some reason...
		} else {
			//alert the user
			siLog('SCORM', 'COMPLETE', 'ERROR: Course could not be set to complete!');
		}
		//If the course isn't connected to the LMS for some reason...
	} else {
		//alert the user
		siLog('SCORM', 'COMPLETE', 'ERROR: Course is not connected to the LMS');
	}
}

function unloadHandler() {
	if (lmsConnected && !unloaded) {
		saveLMS();
		scorm.save(); //save all data that has already been sent
		scorm.quit(); //close the SCORM API connection properly
		unloaded = true;
	}
}
function saveLMS() {
	if (saveCourseProgress() && saveBookmark()) {
		scorm.save();
	} else {
		siLog('SCORM', 'Failed to Save');
	}
}

function saveCourseProgress() {
	var success;
	var dataString = JSON.stringify(slideCompletion);
	if (lmsConnected) {
		success = scorm.set('cmi.suspend_data', dataString);
	}
	return success;
}
function saveBookmark() {
	var success;
	bookmarkedSlide = slides[globalVar.curSlide].slideNumber || '0';
	if (lmsConnected) {
		if (scorm.version === '2004') {
			success = scorm.set('cmi.location', bookmarkedSlide);
		} else {
			success = scorm.set('cmi.core.lesson_location', bookmarkedSlide);
		}
	}

	return success;
}

function saveProgressLocally() {
	bookmarkedSlide = slides[globalVar.curSlide].slideNumber || '0';
	var dataString = JSON.stringify(slideCompletion);
	if (storageAvailable('localStorage')) {
		localStorage.setItem(progressURL, dataString);
		localStorage.setItem(bookmarkURL, bookmarkedSlide);
	}
}

function storageAvailable(type) {
	var storage;
	try {
		storage = window[type];
		var x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return (
			e instanceof DOMException &&
			// everything except Firefox
			(e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === 'QuotaExceededError' ||
				// Firefox
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0
		);
	}
}

// Old Functions

//////////////*Feature:LMS/////////////////////////////////////////////////////////////////////////////////////////////////////
// function sendDataToLMS() {
// 	return correctAnswers; //add your additional variables here(string or variables, seperated by comma and only numbers are allowed)
// }

// function recieveDataFromLMS() {
// 	return 'correctAnswers'; //names of the variables that you send(see sendDatatoLMS)
// }

// function bookMarkingToLMS() {
// 	return (curChapter = slides[globalVar.curSlide].slideNumber);
// }

// function smar_sendDataToLMS() {
// 	var str = '';
// 	//gets all chapter variables
// 	for (var i = 1; i <= chap_nums; i++) {
// 		if (isNaN(window['C_Q' + i])) {
// 			window['C_Q' + i] = 0;
// 		}

// 		if (i < chap_nums) {
// 			str += window['C_Q' + i] + ',';
// 		} else {
// 			str += window['C_Q' + i];
// 		}
// 	}

// 	if (
// 		sendDataToLMS()
// 		.toString()
// 		.indexOf(',') > 0
// 	) {
// 		var tempAry = sendDataToLMS()
// 			.toString()
// 			.split(',');
// 	} else {
// 		var tempAry = [];
// 		tempAry[0] = sendDataToLMS().toString();
// 	}
// 	var _str = '';
// 	for (var i = 0; i < tempAry.length; i++) {
// 		if (isNaN(parseInt(tempAry[i]))) {
// 			tempAry[i] = 0;
// 		}
// 		if (i < tempAry.length) {
// 			_str += tempAry[i] + ',';
// 		}
// 	}
// 	scorm.set('cmi.suspend_data', _str + str);

// 	if (globalVar.scormSettings.bookmarking.useBookmarking && globalVar.scormSettings.useScorm) {
// 		if (bookMarkingToLMS() !== undefined) {
// 			if (scorm.version === '2004') {
// 				scorm.set('cmi.location', bookMarkingToLMS());
// 			} else {
// 				scorm.set('cmi.core.lesson_location', bookMarkingToLMS());
// 			}
// 		} else {
// 			if (scorm.version === '2004') {
// 				scorm.set('cmi.location', '0');
// 			} else {
// 				scorm.set('cmi.core.lesson_location', '0');
// 			}
// 		}
// 	}
// }

// function restoreDataToCourse() {
// 	if (globalVar.scormSettings.useScorm) {
// 		setTimeout(function () {
// 			if (scorm.get('cmi.suspend_data').length > 0) {
// 				var ary = scorm.get('cmi.suspend_data').split(',');
// 				var x = recieveDataFromLMS().split(',');
// 				for (var i = 0; i < x.length; i++) {
// 					window[x[i]] = parseInt(ary[i]);
// 				}
// 				var n = 1;
// 				for (var i = x.length; i < ary.length; i++) {
// 					window['C_Q' + n] = parseInt(ary[i]);
// 					n++;
// 				}
// 				setTimeout(function () {
// 					slides[globalVar.curSlide].onEnterAction();
// 				}, 55);
// 			}
// 		}, 800);

// 		setTimeout(function () {
// 			if (globalVar.scormSettings.bookmarking.useBookmarking && globalVar.scormSettings.useScorm) {
// 				if (scorm.version === '2004') {
// 					window[globalVar.scormSettings.bookmarking.name] = scorm.get('cmi.location');
// 				} else {
// 					window[globalVar.scormSettings.bookmarking.name] = scorm.get('cmi.core.lesson_location');
// 				}
// 				jumpToSlide(window[globalVar.scormSettings.bookmarking.name]);
// 			}
// 		}, 255);
// 	}
// }
